export const PersonHeaderElements = [
  { label: "Nombre", value: "nombre" },
  { label: "Apellido", value: "apellido" },
  { label: "DNI", value: "dni" },
  { label: "CUIL", value: "cuit" },
];
